export default class Items {

    constructor(data) {
        this.allItems = this.loadItems();
    }
    applyPromoCode(code, userdata) {
        if (!code) return;
        if (!userdata) return;
        if (!userdata.items) userdata.items = [];

        //apply code and save as item
        //check if is a code
        var promoCodeItem = this.allItems.find(function (item) {
            if (item.type !== "PromoCode") return false;
            return item.name.toUpperCase() === code.toUpperCase();
        });
        if (!promoCodeItem) {
            const error = { error: true, message: "Code not valid" };
            return error;
        }

        //check if already have it (item)
        if (userdata.items.indexOf(promoCodeItem.name) !== -1) {
            const error = { error: true, message: "This code has already been redeemed" };
            return error;
        }

        //apply coin reward
        if (promoCodeItem.coins) {
            userdata.coins = (userdata.coins || 0) + promoCodeItem.coins;
        }
        //apply no ads
        if (promoCodeItem.item === "NoAds") {
            userdata.removeAds = true;
        }
        //add item
        if (promoCodeItem.item) {
            userdata.items.push(promoCodeItem.item);
        }

        //save promocode to items
        userdata.items.push(promoCodeItem.name);

        return  promoCodeItem; //"You have redeemed: " + promoCodeItem.description;
    }
    getItem(itemName) {
        var item = this.allItems.find(function (item) { return item.name === itemName; });
        return item || null;
    };
    getRandomAvatar() {
        let items = this.allItems.filter(i => i.type === "Avatar");
        let item = items[Math.floor(Math.random() * items.length)];
        return item ? item.url : null;
    }
    loadItems() {
        let allItems = [
            {
                "type": "Board",
                "name": "CribbageBoardClassic",
                "title": "Classic Board",
                "cost": 0,
                "icon": "assets/CribbageBoards/CribbageBoardClassic_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardClassic.png",
                "background": "assets/Backgrounds/WoodBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardGuitar",
                "title": "Guitar Board",
                "cost": 1250,
                "icon": "assets/CribbageBoards/CribbageBoardGuitar_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardGuitar.png",
                "background": "assets/Backgrounds/GreenBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardSalmon",
                "title": "Salmon Board",
                "cost": 1500,
                "icon": "assets/CribbageBoards/CribbageBoardSalmon_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardSalmon.png",
                "background": "assets/Backgrounds/BlueBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardAngler",
                "title": "Angler Board",
                "cost": 1750,
                "icon": "assets/CribbageBoards/CribbageBoardAngler_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardAngler.png",
                "background": "assets/Backgrounds/BlueBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardWhale",
                "title": "Whale Board",
                "cost": 2000,
                "icon": "assets/CribbageBoards/CribbageBoardWhale_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardWhale.png",
                "background": "assets/Backgrounds/RedBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardTruck",
                "title": "Truck 61",
                "cost": 2250,
                "icon": "assets/CribbageBoards/CribbageBoardTruck_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardTruck.png",
                "background": "assets/Backgrounds/GreenBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardTrain",
                "title": "Train Board",
                "cost": 2500,
                "icon": "assets/CribbageBoards/CribbageBoardTrain_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardTrain.png",
                "background": "assets/Backgrounds/WoodBackground.png"
            },

            {
                "type": "Board",
                "name": "CribbageBoardHawaii",
                "title": "Hawaii Board",
                "cost": 2500,
                "icon": "assets/CribbageBoards/CribbageBoardHawaii_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardHawaii.png",
                "background": "assets/Backgrounds/BlueBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardTrail",
                "title": "Trail Board",
                "cost": 3000,
                "icon": "assets/CribbageBoards/CribbageBoardTrail_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardTrail.png",
                "background": "assets/Backgrounds/GreenLightBackground.png"
            },
            {
                "type": "Board",
                "name": "CribbageBoardGold",
                "title": "Gold Board",
                "cost": 3000,
                "icon": "assets/CribbageBoards/CribbageBoardGold_Icon100x200.png",
                "url": "assets/CribbageBoards/CribbageBoardGold.png",
                "background": "assets/Backgrounds/RedBackground.png"
            },
            {
                "type": "Deck",
                "name": "PixaromaDeck",
                "title": "Pixaroma",
                "cost": 0,
                "icon": "assets/Decks/PixaromaDeck_Icon.png",
                "url": "assets/Decks/PixaromaDeck",
                "background": "assets/Backgrounds/BlueBackground.png"
            },
            {
                "type": "Deck",
                "name": "LargeNumberDeck",
                "title": "Simple Large",
                "cost": 300,
                "icon": "assets/Decks/LargeNumberDeck_Icon.png",
                "iconStore": "assets/Decks/LargeNumberDeck_Icon.png",
                "url": "assets/Decks/LargeNumberDeck",
                "background": "assets/Backgrounds/WoodBackground.png"
            },
            {
                "type": "Deck",
                "name": "ClassicDeck",
                "title": "Classic",
                "cost": 500,
                "icon": "assets/Decks/ClassicDeck_Icon.png",
                "url": "assets/Decks/ClassicDeck",
                "background": "assets/Backgrounds/GreenLightBackground.png",
            },
            {
                "type": "Deck",
                "name": "FantasyDeck",
                "title": "Fantasy",
                "cost": 1000,
                "icon": "assets/Decks/FantasyDeck_Icon.png",
                "url": "assets/Decks/FantasyDeck",
                "background": "assets/Backgrounds/BlueBackground.png"
            },
            {
                "type": "Deck",
                "name": "WildWestDeck",
                "title": "Wild West",
                "cost": 1500,
                "icon": "assets/Decks/WildWestDeck_Icon.png",
                "url": "assets/Decks/WildWestDeck",
                "background": "assets/Backgrounds/WoodBackground.png"
            },
            {
                "type": "Deck",
                "name": "HalloweenDeck",
                "title": "Halloween",
                "cost": 1500,
                "icon": "assets/Decks/HalloweenDeck_Icon.png",
                "url": "assets/Decks/HalloweenDeck",
                "background": "assets/Backgrounds/RedBackground.png"
            },
            {
                "type": "Deck",
                "name": "PirateDeck",
                "title": "Pirate",
                "cost": 2000,
                "icon": "assets/Decks/PirateDeck_Icon.png",
                "url": "assets/Decks/PirateDeck",
                "background": "assets/Backgrounds/GreenBackground.png"
            },
            {
                "type": "Deck",
                "name": "MedievalDeck",
                "title": "Royalty",
                "cost": 2500,
                "icon": "assets/Decks/MedievalDeck_Icon.png",
                "url": "assets/Decks/MedievalDeck",
                "background": "assets/Backgrounds/GreenLightBackground.png"
            },            
            {
                "type": "Deck",
                "name": "BlueberryDeck",
                "title": "Blueberry",
                "cost": '?',
                "icon": "assets/Decks/BlueberryDeck_Icon.png",
                "url": "assets/Decks/BlueberryDeck",
                "background": "assets/Backgrounds/BlueBackground.png",
                "codeOnly": true,
                "message": "Code required to unlock. <br> The code is the 'city' of the blueberry farm for <a href='https://www.google.com/search?q=aurora+oregon+blueberry+farm' target='_system'>TheDickinsonFarm.com</a>"
            },
            {
                "type": "Background",
                "name": "WoodBackground",
                "title": "Wood",
                "cost": 0,
                "icon": "assets/Backgrounds/WoodBackground.png",
                "url": "assets/Backgrounds/WoodBackground.png"
            },
            {
                "type": "Background",
                "name": "BlueBackground",
                "title": "Blue",
                "cost": 500,
                "icon": "assets/Backgrounds/BlueBackground.png",
                "url": "assets/Backgrounds/BlueBackground.png"
            },
            {
                "type": "Background",
                "name": "GreenBackground",
                "title": "Green",
                "cost": 750,
                "icon": "assets/Backgrounds/GreenBackground.png",
                "url": "assets/Backgrounds/GreenBackground.png"
            },
            {
                "type": "Background",
                "name": "RedBackground",
                "title": "Red",
                "cost": 1000,
                "icon": "assets/Backgrounds/RedBackground.png",
                "url": "assets/Backgrounds/RedBackground.png"
            },
            {
                "type": "Background",
                "name": "GreenLightBackground",
                "title": "Green Light",
                "cost": 1250,
                "icon": "assets/Backgrounds/GreenLightBackground.png",
                "url": "assets/Backgrounds/GreenLightBackground.png"
            },
            // {
            //     "type": "Background",
            //     "name": "TrainBackground",
            //     "title": "Train Wood",
            //     "cost": 1000,
            //     "icon": "assets/Backgrounds/TrainBackground.jpg",
            //     "url": "assets/Backgrounds/TrainBackground.jpg"
            // },

            // {
            //     "type": "Background",
            //     "name": "FantasyBackground",
            //     "title": "Green Light",
            //     "cost": 1000,
            //     "icon": "assets/Backgrounds/FantasyBackground.png",
            //     "url": "assets/Backgrounds/FantasyBackground.png"
            // },
            {
                "type": "GameMode",
                "name": "InsaneMonkey",
                "description": "The fastest speed monkey in the world!",
                "icon": "images/Avatars/InsaneMonkey.png",
                "cost": 500
            },
            {
                "type": "GameMode",
                "name": "UltraCheetah",
                "description": "She is so fast, she is practically 'Cheet-ing'",
                "icon": "images/Avatars/UltraCheetah.png",
                "cost": 1000
            },
            {
                "type": "GameMode",
                "name": "Impossible",
                "description": "This speed is impossibly fast, it should not be allowed.",
                "icon": "images/Avatars/Impossible.png",
                "cost": 1250
            },
            {
                "type": "GameMode",
                "name": "Doubles",
                "description": "This game mode allows you play the same number on top of it (offline only)",
                "icon": "images/IAP/GameModes.png",
                "cost": 1000
            },
            {
                "type": "GameMode",
                "name": "BigHand",
                "description": "Hold all the cards in your hand.  No drawing cards. (offline only)",
                "icon": "images/IAP/GameModes.png",
                "cost": 1000
            },
            {
                "type": "PromoCode",
                "name": "Deck-Bear",
                "description": "ClassicDeck",
                "icon": "assets/Decks/ClassicDeck_Icon.png",
                "item": "ClassicDeck"
            },
            {
                "type": "PromoCode",
                "name": "Deck-Batman",
                "description": "HalloweenDeck",
                "icon": "assets/Decks/HalloweenDeck_Icon.png",
                "item": "HalloweenDeck"
            },
             {
                "type": "PromoCode",
                "name": "Aurora",
                "description": "Blueberry Deck",
                "icon": "assets/Decks/BlueberryDeck_Icon.png",
                "item": "BlueberryDeck"
            },
            {
                "type": "PromoCode",
                "name": "Coins100-Starter",
                "description": "300 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 200
            },
            {
                "type": "PromoCode",
                "name": "Coins200-MooMoo",
                "description": "200 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 200
            },
            {
                "type": "PromoCode",
                "name": "Coins200-Bat",
                "description": "200 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 200
            },
            {
                "type": "PromoCode",
                "name": "Coins200-Chicken",
                "description": "200 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 200
            },
            {
                "type": "PromoCode",
                "name": "Coins300-Cat",
                "description": "300 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 300
            },
            {
                "type": "PromoCode",
                "name": "Coins300-Monkey",
                "description": "300 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 300
            },
            {
                "type": "PromoCode",
                "name": "Coins300-Ninja",
                "description": "300 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 300
            },
            {
                "type": "PromoCode",
                "name": "Coins300-Bird",
                "description": "300 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 300
            },
            {
                "type": "PromoCode",
                "name": "Coins300-Cow",
                "description": "300 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 300
            },
            {
                "type": "PromoCode",
                "name": "Coins500-Fish",
                "description": "500 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 500
            },
            {
                "type": "PromoCode",
                "name": "Coins500-Love",
                "description": "500 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 500
            },
            {
                "type": "PromoCode",
                "name": "Coins500-Amor",
                "description": "500 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 500
            },
            {
                "type": "PromoCode",
                "name": "Coins1000-Cheese",
                "description": "1000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 1000
            },
            {
                "type": "PromoCode",
                "name": "Coins2000-Truck",
                "description": "2000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 2000
            },
            {
                "type": "PromoCode",
                "name": "Coins5000-Moo",
                "description": "5000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 5000
            },
            {
                "type": "PromoCode",
                "name": "Coins10000-Dog",
                "description": "10000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 10000
            },
            {
                "type": "PromoCode",
                "name": "Coins20000-Bird",
                "description": "20000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 20000
            },
            {
                "type": "PromoCode",
                "name": "Coins20000-Car",
                "description": "20000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 20000
            },
            {
                "type": "PromoCode",
                "name": "Coins20000-Cow",
                "description": "20000 coins",
                "icon": "images/Avatars/Impossible.png",
                "coins": 20000
            },
            {
                "type": "PromoCode",
                "name": "Ads-GoAway",
                "description": "Remove Ads",
                "icon": "images/IAP/NoAds.png",
                "item": "NoAds"
            },
            //{
            //    "type": "Avatar",
            //    "name": "default-avatar",
            //    "cost": 0,
            //    "icon": "images/Avatars/default-avatar.png",
            //    "url": "images/Avatars/default-avatar.png"
            //},
            // {
            //     "type": "Avatar",
            //     "name": "default",
            //     "cost": 0,
            //     "icon": "assets/Avatars/default-avatar.png",
            //     "url": "assets/Avatars/default-avatar.png"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "agent",
            //     "cost": 0,
            //     "icon": "assets/Avatars/agent.png",
            //     "url": "assets/Avatars/agent.png"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "agent_female",
            //     "cost": 0,
            //     "icon": "assets/Avatars/agent_female.png",
            //     "url": "assets/Avatars/agent_female.png"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-1",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-1.jpg",
            //     "url": "assets/Avatars/person-1.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-2",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-2.jpg",
            //     "url": "assets/Avatars/person-2.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-3",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-3.jpg",
            //     "url": "assets/Avatars/person-3.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-4",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-4.jpg",
            //     "url": "assets/Avatars/person-4.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-5",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-5.jpg",
            //     "url": "assets/Avatars/person-5.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-6",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-6.jpg",
            //     "url": "assets/Avatars/person-6.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-7",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-7.jpg",
            //     "url": "assets/Avatars/person-7.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-8",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-8.jpg",
            //     "url": "assets/Avatars/person-8.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-9",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-9.jpg",
            //     "url": "assets/Avatars/person-9.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-10",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-10.jpg",
            //     "url": "assets/Avatars/person-10.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-11",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-11.jpg",
            //     "url": "assets/Avatars/person-11.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-12",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-12.jpg",
            //     "url": "assets/Avatars/person-12.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-13",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-13.jpg",
            //     "url": "assets/Avatars/person-13.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-14",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-14.jpg",
            //     "url": "assets/Avatars/person-14.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-15",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-15.jpg",
            //     "url": "assets/Avatars/person-15.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-16",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-16.jpg",
            //     "url": "assets/Avatars/person-16.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-17",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-17.jpg",
            //     "url": "assets/Avatars/person-17.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-18",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-18.jpg",
            //     "url": "assets/Avatars/person-18.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-19",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-19.jpg",
            //     "url": "assets/Avatars/person-19.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-20",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-20.jpg",
            //     "url": "assets/Avatars/person-20.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-21",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-21.jpg",
            //     "url": "assets/Avatars/person-21.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-22",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-22.jpg",
            //     "url": "assets/Avatars/person-22.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-23",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-23.jpg",
            //     "url": "assets/Avatars/person-23.jpg"
            // },
            // {
            //     "type": "Avatar",
            //     "name": "person-24",
            //     "cost": 0,
            //     "icon": "assets/Avatars/person-24.jpg",
            //     "url": "assets/Avatars/person-24.jpg"
            // },
            {
                "type": "Avatar",
                "name": "AvatarVV_0001",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0001.png",
                "url": "assets/Avatars/vv/AvatarVV_0001.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0002",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0002.png",
                "url": "assets/Avatars/vv/AvatarVV_0002.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0003",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0003.png",
                "url": "assets/Avatars/vv/AvatarVV_0003.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0004",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0004.png",
                "url": "assets/Avatars/vv/AvatarVV_0004.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0005",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0005.png",
                "url": "assets/Avatars/vv/AvatarVV_0005.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0006",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0006.png",
                "url": "assets/Avatars/vv/AvatarVV_0006.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0007",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0007.png",
                "url": "assets/Avatars/vv/AvatarVV_0007.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0008",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0008.png",
                "url": "assets/Avatars/vv/AvatarVV_0008.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0009",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0009.png",
                "url": "assets/Avatars/vv/AvatarVV_0009.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0010",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0010.png",
                "url": "assets/Avatars/vv/AvatarVV_0010.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0011",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0011.png",
                "url": "assets/Avatars/vv/AvatarVV_0011.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0012",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0012.png",
                "url": "assets/Avatars/vv/AvatarVV_0012.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0013",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0013.png",
                "url": "assets/Avatars/vv/AvatarVV_0013.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0014",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0014.png",
                "url": "assets/Avatars/vv/AvatarVV_0014.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0015",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0015.png",
                "url": "assets/Avatars/vv/AvatarVV_0015.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0016",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0016.png",
                "url": "assets/Avatars/vv/AvatarVV_0016.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0017",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0017.png",
                "url": "assets/Avatars/vv/AvatarVV_0017.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0018",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0018.png",
                "url": "assets/Avatars/vv/AvatarVV_0018.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0019",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0019.png",
                "url": "assets/Avatars/vv/AvatarVV_0019.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0020",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0020.png",
                "url": "assets/Avatars/vv/AvatarVV_0020.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0021",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0021.png",
                "url": "assets/Avatars/vv/AvatarVV_0021.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0022",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0022.png",
                "url": "assets/Avatars/vv/AvatarVV_0022.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0023",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0023.png",
                "url": "assets/Avatars/vv/AvatarVV_0023.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0024",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0024.png",
                "url": "assets/Avatars/vv/AvatarVV_0024.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0025",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0025.png",
                "url": "assets/Avatars/vv/AvatarVV_0025.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0026",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0026.png",
                "url": "assets/Avatars/vv/AvatarVV_0026.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0027",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0027.png",
                "url": "assets/Avatars/vv/AvatarVV_0027.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0028",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0028.png",
                "url": "assets/Avatars/vv/AvatarVV_0028.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0029",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0029.png",
                "url": "assets/Avatars/vv/AvatarVV_0029.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0030",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0030.png",
                "url": "assets/Avatars/vv/AvatarVV_0030.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0031",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0031.png",
                "url": "assets/Avatars/vv/AvatarVV_0031.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0032",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0032.png",
                "url": "assets/Avatars/vv/AvatarVV_0032.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0033",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0033.png",
                "url": "assets/Avatars/vv/AvatarVV_0033.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0034",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0034.png",
                "url": "assets/Avatars/vv/AvatarVV_0034.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0035",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0035.png",
                "url": "assets/Avatars/vv/AvatarVV_0035.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0036",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0036.png",
                "url": "assets/Avatars/vv/AvatarVV_0036.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0037",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0037.png",
                "url": "assets/Avatars/vv/AvatarVV_0037.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0038",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0038.png",
                "url": "assets/Avatars/vv/AvatarVV_0038.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0039",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0039.png",
                "url": "assets/Avatars/vv/AvatarVV_0039.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0040",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0040.png",
                "url": "assets/Avatars/vv/AvatarVV_0040.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0041",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0041.png",
                "url": "assets/Avatars/vv/AvatarVV_0041.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0042",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0042.png",
                "url": "assets/Avatars/vv/AvatarVV_0042.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0043",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0043.png",
                "url": "assets/Avatars/vv/AvatarVV_0043.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0044",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0044.png",
                "url": "assets/Avatars/vv/AvatarVV_0044.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0045",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0045.png",
                "url": "assets/Avatars/vv/AvatarVV_0045.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0046",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0046.png",
                "url": "assets/Avatars/vv/AvatarVV_0046.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0047",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0047.png",
                "url": "assets/Avatars/vv/AvatarVV_0047.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0048",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0048.png",
                "url": "assets/Avatars/vv/AvatarVV_0048.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0049",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0049.png",
                "url": "assets/Avatars/vv/AvatarVV_0049.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0050",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0050.png",
                "url": "assets/Avatars/vv/AvatarVV_0050.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0051",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0051.png",
                "url": "assets/Avatars/vv/AvatarVV_0051.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0052",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0052.png",
                "url": "assets/Avatars/vv/AvatarVV_0052.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0053",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0053.png",
                "url": "assets/Avatars/vv/AvatarVV_0053.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0054",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0054.png",
                "url": "assets/Avatars/vv/AvatarVV_0054.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0055",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0055.png",
                "url": "assets/Avatars/vv/AvatarVV_0055.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0056",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0056.png",
                "url": "assets/Avatars/vv/AvatarVV_0056.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0057",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0057.png",
                "url": "assets/Avatars/vv/AvatarVV_0057.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0058",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0058.png",
                "url": "assets/Avatars/vv/AvatarVV_0058.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0059",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0059.png",
                "url": "assets/Avatars/vv/AvatarVV_0059.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0060",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0060.png",
                "url": "assets/Avatars/vv/AvatarVV_0060.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0061",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0061.png",
                "url": "assets/Avatars/vv/AvatarVV_0061.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0062",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0062.png",
                "url": "assets/Avatars/vv/AvatarVV_0062.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0063",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0063.png",
                "url": "assets/Avatars/vv/AvatarVV_0063.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0064",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0064.png",
                "url": "assets/Avatars/vv/AvatarVV_0064.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0065",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0065.png",
                "url": "assets/Avatars/vv/AvatarVV_0065.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0066",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0066.png",
                "url": "assets/Avatars/vv/AvatarVV_0066.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0067",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0067.png",
                "url": "assets/Avatars/vv/AvatarVV_0067.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0068",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0068.png",
                "url": "assets/Avatars/vv/AvatarVV_0068.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0069",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0069.png",
                "url": "assets/Avatars/vv/AvatarVV_0069.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0070",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0070.png",
                "url": "assets/Avatars/vv/AvatarVV_0070.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0071",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0071.png",
                "url": "assets/Avatars/vv/AvatarVV_0071.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0072",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0072.png",
                "url": "assets/Avatars/vv/AvatarVV_0072.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0073",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0073.png",
                "url": "assets/Avatars/vv/AvatarVV_0073.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0074",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0074.png",
                "url": "assets/Avatars/vv/AvatarVV_0074.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0075",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0075.png",
                "url": "assets/Avatars/vv/AvatarVV_0075.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0076",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0076.png",
                "url": "assets/Avatars/vv/AvatarVV_0076.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0077",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0077.png",
                "url": "assets/Avatars/vv/AvatarVV_0077.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0078",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0078.png",
                "url": "assets/Avatars/vv/AvatarVV_0078.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0079",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0079.png",
                "url": "assets/Avatars/vv/AvatarVV_0079.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0080",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0080.png",
                "url": "assets/Avatars/vv/AvatarVV_0080.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0081",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0081.png",
                "url": "assets/Avatars/vv/AvatarVV_0081.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0082",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0082.png",
                "url": "assets/Avatars/vv/AvatarVV_0082.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0083",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0083.png",
                "url": "assets/Avatars/vv/AvatarVV_0083.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0084",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0084.png",
                "url": "assets/Avatars/vv/AvatarVV_0084.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0085",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0085.png",
                "url": "assets/Avatars/vv/AvatarVV_0085.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0086",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0086.png",
                "url": "assets/Avatars/vv/AvatarVV_0086.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0087",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0087.png",
                "url": "assets/Avatars/vv/AvatarVV_0087.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0088",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0088.png",
                "url": "assets/Avatars/vv/AvatarVV_0088.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0089",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0089.png",
                "url": "assets/Avatars/vv/AvatarVV_0089.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0090",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0090.png",
                "url": "assets/Avatars/vv/AvatarVV_0090.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0091",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0091.png",
                "url": "assets/Avatars/vv/AvatarVV_0091.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0092",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0092.png",
                "url": "assets/Avatars/vv/AvatarVV_0092.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0093",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0093.png",
                "url": "assets/Avatars/vv/AvatarVV_0093.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0094",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0094.png",
                "url": "assets/Avatars/vv/AvatarVV_0094.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0095",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0095.png",
                "url": "assets/Avatars/vv/AvatarVV_0095.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0096",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0096.png",
                "url": "assets/Avatars/vv/AvatarVV_0096.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0097",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0097.png",
                "url": "assets/Avatars/vv/AvatarVV_0097.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0098",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0098.png",
                "url": "assets/Avatars/vv/AvatarVV_0098.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0099",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0099.png",
                "url": "assets/Avatars/vv/AvatarVV_0099.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0100",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0100.png",
                "url": "assets/Avatars/vv/AvatarVV_0100.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0101",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0101.png",
                "url": "assets/Avatars/vv/AvatarVV_0101.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0102",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0102.png",
                "url": "assets/Avatars/vv/AvatarVV_0102.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0103",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0103.png",
                "url": "assets/Avatars/vv/AvatarVV_0103.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0104",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0104.png",
                "url": "assets/Avatars/vv/AvatarVV_0104.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0105",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0105.png",
                "url": "assets/Avatars/vv/AvatarVV_0105.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0106",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0106.png",
                "url": "assets/Avatars/vv/AvatarVV_0106.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0107",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0107.png",
                "url": "assets/Avatars/vv/AvatarVV_0107.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0108",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0108.png",
                "url": "assets/Avatars/vv/AvatarVV_0108.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0109",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0109.png",
                "url": "assets/Avatars/vv/AvatarVV_0109.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0110",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0110.png",
                "url": "assets/Avatars/vv/AvatarVV_0110.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0111",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0111.png",
                "url": "assets/Avatars/vv/AvatarVV_0111.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0112",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0112.png",
                "url": "assets/Avatars/vv/AvatarVV_0112.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0113",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0113.png",
                "url": "assets/Avatars/vv/AvatarVV_0113.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0114",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0114.png",
                "url": "assets/Avatars/vv/AvatarVV_0114.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0115",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0115.png",
                "url": "assets/Avatars/vv/AvatarVV_0115.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0116",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0116.png",
                "url": "assets/Avatars/vv/AvatarVV_0116.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0117",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0117.png",
                "url": "assets/Avatars/vv/AvatarVV_0117.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0118",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0118.png",
                "url": "assets/Avatars/vv/AvatarVV_0118.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0119",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0119.png",
                "url": "assets/Avatars/vv/AvatarVV_0119.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0120",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0120.png",
                "url": "assets/Avatars/vv/AvatarVV_0120.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0121",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0121.png",
                "url": "assets/Avatars/vv/AvatarVV_0121.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0122",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0122.png",
                "url": "assets/Avatars/vv/AvatarVV_0122.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0123",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0123.png",
                "url": "assets/Avatars/vv/AvatarVV_0123.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0124",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0124.png",
                "url": "assets/Avatars/vv/AvatarVV_0124.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0125",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0125.png",
                "url": "assets/Avatars/vv/AvatarVV_0125.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0126",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0126.png",
                "url": "assets/Avatars/vv/AvatarVV_0126.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0127",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0127.png",
                "url": "assets/Avatars/vv/AvatarVV_0127.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0128",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0128.png",
                "url": "assets/Avatars/vv/AvatarVV_0128.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0129",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0129.png",
                "url": "assets/Avatars/vv/AvatarVV_0129.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0130",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0130.png",
                "url": "assets/Avatars/vv/AvatarVV_0130.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0131",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0131.png",
                "url": "assets/Avatars/vv/AvatarVV_0131.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0132",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0132.png",
                "url": "assets/Avatars/vv/AvatarVV_0132.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0133",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0133.png",
                "url": "assets/Avatars/vv/AvatarVV_0133.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0134",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0134.png",
                "url": "assets/Avatars/vv/AvatarVV_0134.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0135",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0135.png",
                "url": "assets/Avatars/vv/AvatarVV_0135.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0136",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0136.png",
                "url": "assets/Avatars/vv/AvatarVV_0136.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0137",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0137.png",
                "url": "assets/Avatars/vv/AvatarVV_0137.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0138",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0138.png",
                "url": "assets/Avatars/vv/AvatarVV_0138.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0139",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0139.png",
                "url": "assets/Avatars/vv/AvatarVV_0139.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0140",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0140.png",
                "url": "assets/Avatars/vv/AvatarVV_0140.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0141",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0141.png",
                "url": "assets/Avatars/vv/AvatarVV_0141.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0142",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0142.png",
                "url": "assets/Avatars/vv/AvatarVV_0142.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0143",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0143.png",
                "url": "assets/Avatars/vv/AvatarVV_0143.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0144",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0144.png",
                "url": "assets/Avatars/vv/AvatarVV_0144.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0145",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0145.png",
                "url": "assets/Avatars/vv/AvatarVV_0145.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0146",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0146.png",
                "url": "assets/Avatars/vv/AvatarVV_0146.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0147",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0147.png",
                "url": "assets/Avatars/vv/AvatarVV_0147.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0148",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0148.png",
                "url": "assets/Avatars/vv/AvatarVV_0148.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0149",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0149.png",
                "url": "assets/Avatars/vv/AvatarVV_0149.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0150",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0150.png",
                "url": "assets/Avatars/vv/AvatarVV_0150.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0151",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0151.png",
                "url": "assets/Avatars/vv/AvatarVV_0151.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0152",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0152.png",
                "url": "assets/Avatars/vv/AvatarVV_0152.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0153",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0153.png",
                "url": "assets/Avatars/vv/AvatarVV_0153.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0154",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0154.png",
                "url": "assets/Avatars/vv/AvatarVV_0154.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0155",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0155.png",
                "url": "assets/Avatars/vv/AvatarVV_0155.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0156",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0156.png",
                "url": "assets/Avatars/vv/AvatarVV_0156.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0157",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0157.png",
                "url": "assets/Avatars/vv/AvatarVV_0157.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0158",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0158.png",
                "url": "assets/Avatars/vv/AvatarVV_0158.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0159",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0159.png",
                "url": "assets/Avatars/vv/AvatarVV_0159.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0160",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0160.png",
                "url": "assets/Avatars/vv/AvatarVV_0160.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0161",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0161.png",
                "url": "assets/Avatars/vv/AvatarVV_0161.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0162",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0162.png",
                "url": "assets/Avatars/vv/AvatarVV_0162.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0163",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0163.png",
                "url": "assets/Avatars/vv/AvatarVV_0163.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0164",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0164.png",
                "url": "assets/Avatars/vv/AvatarVV_0164.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0165",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0165.png",
                "url": "assets/Avatars/vv/AvatarVV_0165.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0166",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0166.png",
                "url": "assets/Avatars/vv/AvatarVV_0166.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0167",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0167.png",
                "url": "assets/Avatars/vv/AvatarVV_0167.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0168",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0168.png",
                "url": "assets/Avatars/vv/AvatarVV_0168.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0169",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0169.png",
                "url": "assets/Avatars/vv/AvatarVV_0169.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0170",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0170.png",
                "url": "assets/Avatars/vv/AvatarVV_0170.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0171",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0171.png",
                "url": "assets/Avatars/vv/AvatarVV_0171.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0172",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0172.png",
                "url": "assets/Avatars/vv/AvatarVV_0172.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0173",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0173.png",
                "url": "assets/Avatars/vv/AvatarVV_0173.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0174",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0174.png",
                "url": "assets/Avatars/vv/AvatarVV_0174.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0175",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0175.png",
                "url": "assets/Avatars/vv/AvatarVV_0175.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0176",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0176.png",
                "url": "assets/Avatars/vv/AvatarVV_0176.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0177",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0177.png",
                "url": "assets/Avatars/vv/AvatarVV_0177.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0178",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0178.png",
                "url": "assets/Avatars/vv/AvatarVV_0178.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0179",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0179.png",
                "url": "assets/Avatars/vv/AvatarVV_0179.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0180",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0180.png",
                "url": "assets/Avatars/vv/AvatarVV_0180.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0181",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0181.png",
                "url": "assets/Avatars/vv/AvatarVV_0181.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0182",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0182.png",
                "url": "assets/Avatars/vv/AvatarVV_0182.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0183",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0183.png",
                "url": "assets/Avatars/vv/AvatarVV_0183.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0184",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0184.png",
                "url": "assets/Avatars/vv/AvatarVV_0184.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0185",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0185.png",
                "url": "assets/Avatars/vv/AvatarVV_0185.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0186",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0186.png",
                "url": "assets/Avatars/vv/AvatarVV_0186.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0187",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0187.png",
                "url": "assets/Avatars/vv/AvatarVV_0187.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0188",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0188.png",
                "url": "assets/Avatars/vv/AvatarVV_0188.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0189",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0189.png",
                "url": "assets/Avatars/vv/AvatarVV_0189.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0190",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0190.png",
                "url": "assets/Avatars/vv/AvatarVV_0190.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0191",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0191.png",
                "url": "assets/Avatars/vv/AvatarVV_0191.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0192",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0192.png",
                "url": "assets/Avatars/vv/AvatarVV_0192.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0193",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0193.png",
                "url": "assets/Avatars/vv/AvatarVV_0193.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0194",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0194.png",
                "url": "assets/Avatars/vv/AvatarVV_0194.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0195",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0195.png",
                "url": "assets/Avatars/vv/AvatarVV_0195.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0196",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0196.png",
                "url": "assets/Avatars/vv/AvatarVV_0196.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0197",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0197.png",
                "url": "assets/Avatars/vv/AvatarVV_0197.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0198",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0198.png",
                "url": "assets/Avatars/vv/AvatarVV_0198.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0199",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0199.png",
                "url": "assets/Avatars/vv/AvatarVV_0199.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0200",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0200.png",
                "url": "assets/Avatars/vv/AvatarVV_0200.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0201",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0201.png",
                "url": "assets/Avatars/vv/AvatarVV_0201.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0202",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0202.png",
                "url": "assets/Avatars/vv/AvatarVV_0202.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0203",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0203.png",
                "url": "assets/Avatars/vv/AvatarVV_0203.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0204",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0204.png",
                "url": "assets/Avatars/vv/AvatarVV_0204.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0205",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0205.png",
                "url": "assets/Avatars/vv/AvatarVV_0205.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0206",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0206.png",
                "url": "assets/Avatars/vv/AvatarVV_0206.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0207",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0207.png",
                "url": "assets/Avatars/vv/AvatarVV_0207.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0208",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0208.png",
                "url": "assets/Avatars/vv/AvatarVV_0208.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0209",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0209.png",
                "url": "assets/Avatars/vv/AvatarVV_0209.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0210",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0210.png",
                "url": "assets/Avatars/vv/AvatarVV_0210.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0211",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0211.png",
                "url": "assets/Avatars/vv/AvatarVV_0211.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0212",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0212.png",
                "url": "assets/Avatars/vv/AvatarVV_0212.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0213",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0213.png",
                "url": "assets/Avatars/vv/AvatarVV_0213.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0214",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0214.png",
                "url": "assets/Avatars/vv/AvatarVV_0214.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0215",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0215.png",
                "url": "assets/Avatars/vv/AvatarVV_0215.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0216",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0216.png",
                "url": "assets/Avatars/vv/AvatarVV_0216.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0217",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0217.png",
                "url": "assets/Avatars/vv/AvatarVV_0217.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0218",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0218.png",
                "url": "assets/Avatars/vv/AvatarVV_0218.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0219",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0219.png",
                "url": "assets/Avatars/vv/AvatarVV_0219.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0220",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0220.png",
                "url": "assets/Avatars/vv/AvatarVV_0220.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0221",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0221.png",
                "url": "assets/Avatars/vv/AvatarVV_0221.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0222",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0222.png",
                "url": "assets/Avatars/vv/AvatarVV_0222.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0223",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0223.png",
                "url": "assets/Avatars/vv/AvatarVV_0223.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0224",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0224.png",
                "url": "assets/Avatars/vv/AvatarVV_0224.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0225",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0225.png",
                "url": "assets/Avatars/vv/AvatarVV_0225.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0226",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0226.png",
                "url": "assets/Avatars/vv/AvatarVV_0226.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0227",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0227.png",
                "url": "assets/Avatars/vv/AvatarVV_0227.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0228",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0228.png",
                "url": "assets/Avatars/vv/AvatarVV_0228.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0229",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0229.png",
                "url": "assets/Avatars/vv/AvatarVV_0229.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0230",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0230.png",
                "url": "assets/Avatars/vv/AvatarVV_0230.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0231",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0231.png",
                "url": "assets/Avatars/vv/AvatarVV_0231.png"
            },
            {
                "type": "Avatar",
                "name": "AvatarVV_0232",
                "cost": 0,
                "icon": "assets/Avatars/vv/AvatarVV_0232.png",
                "url": "assets/Avatars/vv/AvatarVV_0232.png"
            },
            {
                "type": "IAP",
                "title": "Remove Ads",
                "description": "No more advertisements ever, plus 2,000 coins.",
                "id": 'app.cardgames.cribbage.removeads',
                "name": "removeAds-IAP",
                "icon": "assets/IAP/RemoveAds.png"
            },
            {
                "type": "IAP",
                "title": "1,000 Coins",
                "description": "Yeah, 1,000 coins.",
                "id": 'app.cardgames.cribbage.coins1000',
                "name": "coins1000-IAP",
                "icon": "assets/IAP/Coins2.png"
            },
            {
                "type": "IAP",
                "title": "5,000 Coins",
                "description": "Great value, 5,000 coins.",
                "id": 'app.cardgames.cribbage.coins5000',
                "name": "coins5000-IAP",
                "icon": "assets/IAP/Coins3.png"
            },
            {
                "type": "IAP",
                "title": "10,000 Coins",
                "description": "Super value!, 10,000 coins.",
                "id": 'app.cardgames.cribbage.coins10000',
                "name": "coins10000-IAP",
                "icon": "assets/IAP/CoinsPot.png"
            },
            // {
            //     "type": "IAP",
            //     "title": "20,000 Coins",
            //     "description": "Best value! 20,000 coins.",
            //     "id": 'app.cardgames.cribbage.coins20000',
            //     "name": "coins20000-IAP",
            //     "icon": "assets/IAP/Treasure.png",
            // },
            {
                "type": "IAP",
                "title": "Full Version",
                "description": "No advertisements and all items unlocked",
                "id": 'app.cardgames.cribbage.fullversion',
                "name": "fullVersion-IAP",
                "icon": "assets/IAP/Treasure.png",
                "hidden": true
            }
        ];
        return allItems;
    }

}

